import React, { useEffect, useState } from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import AnneescolaireService from '../../services/AnneescolaireService';
import EleveService from '../../services/EleveService';
import SalledeclasseService from '../../services/SalledeclasseService';
import Logo from 'assets/images/brand/logo/logo-entete.svg';

const PrintInvoiceDetailsListeEleves = React.forwardRef((props, ref) => {
	const { id } = useParams();
	const [eleves, setEleves] = useState([]);
	const [salledeclasse, setSalledeclasse] = useState(null);
	const [currentSchoolYear, setCurrentSchoolYear] = useState(null);

	useEffect(() => {
		const fetchCurrentSchoolYear = async () => {
			try {
				const schoolYear = await AnneescolaireService.getCurrentAnneescolaire();
				setCurrentSchoolYear(schoolYear.data);

				// Maintenant, appelez fetchEleves ici après avoir défini currentSchoolYear
				await fetchEleves(schoolYear.data.id);
			} catch (error) {
				console.error(
					"Erreur lors de la récupération de l'année scolaire en cours:",
					error
				);
				alert(
					`Erreur lors de la récupération de l'année scolaire en cours. Détails de l'erreur : ${error.message}`
				);
			}
		};

		const fetchEleves = async (anneeScolaireId) => {
			try {
				const response = await EleveService.getAllEleves(parseInt(id));
				// filter eleves who belong to the current class
				const filteredEleves = response.filter(
					(eleve) => eleve.anneescolaire === anneeScolaireId
				);
				setEleves(filteredEleves);
			} catch (error) {
				console.error('Error fetching eleves data', error);
			}
		};

		fetchCurrentSchoolYear();
	}, [id]); // Assurez-vous que 'id' est une dépendance à jour

	useEffect(() => {
		const fetchSalledeclasse = async () => {
			try {
				const response = await SalledeclasseService.getSalledeclasse(id);
				setSalledeclasse(response.data);
			} catch (error) {
				console.error('Error fetching salle de classe data', error);
			}
		};

		fetchSalledeclasse();
	}, [id]);

	function formatIntituleClasse(value) {
		return value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
	}

	const scale = 0.9;

	return (
		<div
			ref={ref}
			style={{
				transform: `scale(${scale})`,
				minHeight: '1500px',
				// minHeight: '841.92px',
				transformOrigin: 'top',
				boxSizing: 'border-box'
			}}
			className="d-flex flex-column text-black justify-content-between w-100"
		>
			{salledeclasse && eleves && currentSchoolYear && (
				<>
					<Row className="text-center small mb-5">
						<Col></Col>

						<Col>
							<Image src={Logo} alt="" width="40%" className="mb-4" />
						</Col>

						<Col></Col>
					</Row>

					<Row className="text-center">
						<Col>
							<div
								className="py-2 h3 text-center text-uppercase text-dark fw-bold"
								style={{ backgroundColor: '#b1b1b1' }}
							>
								<span>
									{formatIntituleClasse(
										salledeclasse.intitule_classe
									).toUpperCase()}
								</span>
							</div>
						</Col>
					</Row>

					<Row className="text-center fw-bolder mb-5">
						<Col>
							<div>
								<span>
									{salledeclasse.section === 'fr'
										? `ANNEE SCOLAIRE ${currentSchoolYear.annee_debut} - ${currentSchoolYear.annee_fin}`
										: `ACADEMIC YEAR ${currentSchoolYear.annee_debut} - ${currentSchoolYear.annee_fin}`}
								</span>
							</div>
						</Col>
					</Row>

					<Row className="mb-5">
						<Col>
							<table className="table table-sm table-light table-bordered">
								<thead>
									<tr className="bg-light">
										<th style={{ width: '5%' }}>#</th>
										<th style={{ width: '35%' }}>
											{salledeclasse.section === 'fr' ? 'Nom' : 'Last Name'}
										</th>
										<th style={{ width: '25%' }}>
											{salledeclasse.section === 'fr' ? 'Prénom' : 'First Name'}
										</th>
										<th style={{ width: '10%' }}>
											{salledeclasse.section === 'fr' ? 'Sexe' : 'Gender'}
										</th>
										<th style={{ width: '10%' }}>
											{salledeclasse.section === 'fr'
												? 'Date de Naissance'
												: 'Date of Birth'}
										</th>
										<th style={{ width: '15%' }}>
											{salledeclasse.section === 'fr'
												? 'Lieu de Naissance'
												: 'Place of Birth'}
										</th>
									</tr>
								</thead>
								<tbody>
									{eleves.map((eleve, index) => (
										<tr key={eleve.id}>
											<td>{index + 1}</td>
											<td className="text-uppercase">{eleve.nom}</td>
											<td className="text-capitalize">{eleve.prenom}</td>
											<td>
												{eleve.genre === 'm'
													? salledeclasse.section === 'fr'
														? 'Masculin'
														: 'Male'
													: salledeclasse.section === 'fr'
													? 'Féminin'
													: 'Female'}
											</td>
											<td>
												{new Date(eleve.date_naissance).toLocaleDateString()}
											</td>
											<td className="text-capitalize">
												{eleve.lieu_naissance}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</Col>
					</Row>

					<Row className="text-center mb-auto"></Row>
				</>
			)}
		</div>
	);
});

export default PrintInvoiceDetailsListeEleves;
